const DEV_BASE_LINK = 'http://localhost:8080';
// const PRODUCTION_BASE_LINK = 'https://api.mckany.com';
const PRODUCTION_BASE_LINK = 'https://mckany-backend.herokuapp.com';

let CURRENT_BASE_LINK;

const currentEnv = process.env.NODE_ENV;
if (currentEnv === 'production') {
  CURRENT_BASE_LINK = PRODUCTION_BASE_LINK;
} else {
  CURRENT_BASE_LINK = DEV_BASE_LINK;
}

export const AUTH_WITH_GOOGLE = `${CURRENT_BASE_LINK}/auth/google`;
export const SIGNUP_FORM_SUBMIT = `${CURRENT_BASE_LINK}/auth/signup`;
export const SIGNIN_FORM_SUBMIT = `${CURRENT_BASE_LINK}/auth/signin`;
export const SIGNOUT = `${CURRENT_BASE_LINK}/auth/logout`;
export const ACCESS_TOKEN = `${CURRENT_BASE_LINK}/auth/token`;
export const SELL_WITH_AGENT = `${CURRENT_BASE_LINK}/sell-with-agent`;
